export default "__VITE_ASSET__qdMX8eVf__"